import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Layout from "../../../../components/Layouts/Layouts/Layout";
import DashboardHeader from "../../../../components/basic/DashboardHeader";
import {
  Button,
  Pagination,
  Table,
  Modal,
  Form,
  Row,
  Col,
  Badge,
} from "react-bootstrap";
import { formatDateTimeStandard } from "../../../../components/basic/simpleFunctions";
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import { getURLbyEndPointV2 } from "../../../../store/api";
import axios from "axios";
import BindingTimeTableModal from "./BindingTimeTableModal";

const BindingDispute = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [raiseDisputeData, setRaiseDisputeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showTimeTableModal, setShowTimeTableModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [approvingIds] = useState(new Set());

  const getStatusVariant = (status) => {
    switch (status) {
      case "Pending":
        return "warning";
      case "Document Verification":
        return "info";
      case "Processing":
        return "primary";
      case "Rejected":
        return "danger";
      case "Approved":
        return "success";
      default:
        return "secondary";
    }
  };

  //

  const handleInputChange = (itemId, name, value) => {
    setRaiseDisputeData((prevData) => {
      const updatedData = prevData.map((item) => {
        if (item._id === itemId) {
          return {
            ...item,
            [name]: value,
          };
        }
        return item;
      });
      return updatedData;
    });
  };

  const fetchBindingDisputeData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        getURLbyEndPointV2("getAllBindingDisputesData")
      );
      if (response.status === 200) {
        const data = response.data.data;
        setRaiseDisputeData(data);
      } else {
        console.error("Failed to fetch binding disputes data.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const approveRejectBindingDispute = async (userId, status) => {
    const clientData = raiseDisputeData.find((user) => user._id === userId);

    if (!clientData.remark || clientData.remark.trim() === "") {
      alert("Remark is required.");
      return;
    }

    try {
      const res = await axios.post(
        getURLbyEndPointV2("approveRejectBindingDispute") + userId,
        { status, remark: clientData.remark },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (res.data.status) {
        alert(res.data.message);
        fetchBindingDisputeData();
      } else {
        alert(res.data.message);
      }
    } catch (error) {
      alert("Error while handling event data.");
      console.error("Error:", error);
    }
  };

  const filteredData = raiseDisputeData.filter((data) => {
    if (searchTerm !== "") {
      const lowerSearch = searchTerm.toLowerCase();
      const companyName = data.clientId?.companyName?.toLowerCase() || "";
      const email = data.clientId?.email?.toLowerCase() || "";
      const appNo = data.appNo?.toLowerCase() || "";

      if (
        !companyName.includes(lowerSearch) &&
        !email.includes(lowerSearch) &&
        !appNo.includes(lowerSearch)
      ) {
        return false;
      }
    }
    return true;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentFiltered = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const calculateRange = (currentPage, totalPages) => {
    let startPage = Math.max(1, currentPage - 5);
    let endPage = Math.min(totalPages, currentPage + 4);

    if (endPage - startPage < 9) {
      if (startPage === 1) {
        endPage = Math.min(10, totalPages);
      } else if (endPage === totalPages) {
        startPage = Math.max(totalPages - 9, 1);
      }
    }

    return { startPage, endPage };
  };

  const { startPage, endPage } = calculateRange(currentPage, totalPages);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  useEffect(() => {
    fetchBindingDisputeData();
  }, []);

  // Docs column removed

  return (
    <>
      <Layout>
        <div className="d-flex flex-column justify-content-center align-items-center px-3">
          <div className="main-width d-flex flex-column">
            <hr />
            <DashboardHeader
              heading="Arbitration Center / Raise Your Dispute / Binding"
              backUrl="/raise-your-dispute"
            />
            <hr />
            <div className="d-flex justify-content-between align-items-center mb-3">
              <Form.Control
                type="text"
                placeholder="Search by company name, email or app no..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ maxWidth: "300px" }}
              />
              <Button
                variant="primary"
                onClick={() =>
                  navigate("/raise-your-dispute/binding/recordings")
                }
              >
                View Recordings
              </Button>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <Table responsive striped bordered hover>
                <thead>
                  <tr className="text-center">
                    <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                      Sr No.
                    </th>
                    <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                      User Details
                    </th>
                    <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                      Dispute Details
                    </th>
                    <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                      Application No.
                      <br />& Date Time
                    </th>
                    <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                      Process
                    </th>
                    <th style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                      Action
                    </th>
                  </tr>
                </thead>
                {loading ? (
                  <tbody>
                    <tr>
                      <td colSpan={6} className="text-center">
                        Loading...
                      </td>
                    </tr>
                  </tbody>
                ) : currentFiltered.length > 0 ? (
                  <>
                    {currentFiltered.map((data, dataIndex) => (
                      <tbody className="text-center" key={dataIndex}>
                        <tr>
                          <td>
                            {filteredData.length - indexOfFirstItem - dataIndex}
                            .
                          </td>
                          <td>
                            <div>
                              <div className="fw-bold">
                                {data.clientId.email}
                              </div>
                              <div className="text-nowrap">
                                {data.clientId.companyName}
                              </div>
                              <div className="text-nowrap">
                                {data.clientId.firstName}{" "}
                                {data.clientId.surName}
                              </div>
                              <div>{data.clientId.memberShipNo}</div>
                            </div>
                          </td>
                          <td>
                            <Button
                              variant="info"
                              size="sm"
                              onClick={() => {
                                setSelectedData(data);
                                setShow(true);
                              }}
                            >
                              View Details
                            </Button>
                          </td>

                          <td>
                            <div className="text-nowrap">
                              <>
                                {data.appNo}{" "}
                                <h6 className="text-success">
                                  {formatDateTimeStandard(data.createdAt)}
                                </h6>
                              </>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex justify-content-center align-items-center">
                              <Badge bg={getStatusVariant(data.status)}>
                                {data.status}
                              </Badge>
                            </div>
                          </td>

                          <td>
                            <div className="d-flex flex-column gap-2 align-items-center">
                              {data.status === "Processing" ? (
                                <div className="text-center">
                                  <div className="fw-bold">Remark</div>
                                  <div>{data.remark || "-"}</div>
                                </div>
                              ) : data.status === "Rejected" ? (
                                <div className="text-center">
                                  <div className="fw-bold">Remark</div>
                                  <div>{data.remark || "-"}</div>
                                </div>
                              ) : data.isApproved === "Approved" ? (
                                <>
                                  <div className="text-center">
                                    <div className="fw-bold">Remark</div>
                                    <div>{data.remark || "-"}</div>
                                  </div>
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => {
                                      setSelectedData({
                                        ...data,
                                        timeTable: data.timeTable,
                                        paymentSchedule: data.paymentSchedule,
                                      });
                                      setShowTimeTableModal(true);
                                    }}
                                    className="mt-2"
                                  >
                                    View Time Table
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Form.Group>
                                    <Form.Control
                                      as="textarea"
                                      type="text"
                                      placeholder="Enter a Remark"
                                      required
                                      rows={3}
                                      maxLength={400}
                                      onChange={(e) =>
                                        handleInputChange(
                                          data._id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                      value={data.remark}
                                      name="remark"
                                    />
                                  </Form.Group>
                                  <div className="d-flex gap-3 justify-content-center">
                                    <Button
                                      className="m-0 p-0 border-none"
                                      style={{
                                        backgroundColor: "transparent",
                                        boxShadow: "none",
                                      }}
                                      onClick={() =>
                                        approveRejectBindingDispute(
                                          data._id,
                                          true
                                        )
                                      }
                                      disabled={approvingIds.has(data._id)}
                                    >
                                      {approvingIds.has(data._id) ? (
                                        <div
                                          className="spinner-border spinner-border-sm text-success"
                                          role="status"
                                        >
                                          <span className="visually-hidden">
                                            Loading...
                                          </span>
                                        </div>
                                      ) : (
                                        <AiFillCheckCircle className="w-100 icon-size green-color" />
                                      )}
                                    </Button>
                                    <Button
                                      className="m-0 p-0 border-none"
                                      style={{
                                        backgroundColor: "transparent",
                                        boxShadow: "none",
                                      }}
                                      onClick={() =>
                                        approveRejectBindingDispute(
                                          data._id,
                                          false
                                        )
                                      }
                                    >
                                      <AiFillCloseCircle className="w-100 icon-size text-danger" />
                                    </Button>
                                  </div>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan={6} className="text-center">
                        No Matching Data
                      </td>
                    </tr>
                  </tbody>
                )}
              </Table>
            </div>
            {totalPages > 1 && (
              <div className="d-flex justify-content-start">
                <Pagination>
                  <Pagination.Prev
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                  />
                  {Array.from(
                    { length: endPage - startPage + 1 },
                    (_, index) => (
                      <Pagination.Item
                        key={index + startPage}
                        active={index + startPage === currentPage}
                        onClick={() => handlePageChange(index + startPage)}
                      >
                        {index + startPage}
                      </Pagination.Item>
                    )
                  )}
                  <Pagination.Next
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            )}
          </div>
        </div>
      </Layout>

      <BindingDetailModal
        show={show}
        handleClose={() => setShow(false)}
        selectedData={{
          ...selectedData,
          paymentSchedule: selectedData?.paymentSchedule,
        }}
        key={selectedData?._id}
      />

      <BindingTimeTableModal
        show={showTimeTableModal}
        handleClose={() => setShowTimeTableModal(false)}
        data={{
          ...selectedData,
          timeTable: selectedData?.timeTable,
          paymentSchedule: selectedData?.paymentSchedule,
        }}
      />
    </>
  );
};

export default BindingDispute;

const getDocuments = (data) => {
  const bindingDisputeDocs = [
    { key: "companyRegistrationDoc", name: "Company Registration Document" },
    { key: "agreementContract", name: "Agreement Contract" },
    { key: "arbitrationForm", name: "Arbitration Form" },
    { key: "correspondenceWithSupplier", name: "Correspondence with Supplier" },
    { key: "commercialInvoice", name: "Commercial Invoice" },
    { key: "inspectionReports", name: "Inspection Reports" },
    { key: "correspondenceWithAgent", name: "Correspondence with Agent" },
    { key: "correspondenceWithCarrier", name: "Correspondence with Carrier" },
    { key: "photographs", name: "Photographs" },
    { key: "legalActionDocuments", name: "Legal Action Documents" },
    { key: "claimantStatement", name: "Claimant Statement" },
  ]
    .filter(({ key }) => data[key])
    .map(({ key, name }) => ({
      documentType: name,
      uploadDate: data.createdAt,
      status: "Uploaded",
      url: data[key],
    }));

  // Collect documents from timeTable sections
  const timeTableDocs =
    data.timeTable?.sections?.flatMap((section) =>
      Object.entries(section.documents || {}).map(([docKey, url]) => ({
        documentType: `${section.sectionName} - ${docKey}`,
        uploadDate: section.completedAt || section.createdAt || data.createdAt,
        status: section.isCompleted ? "Uploaded" : "Pending",
        url,
      }))
    ) || [];

  return [...bindingDisputeDocs, ...timeTableDocs];
};

const BindingDetailModal = ({ show, handleClose, selectedData }) => {
  const [selectedDoc, setSelectedDoc] = useState(null);

  useEffect(() => {
    if (!show) {
      setSelectedDoc(null);
    }
  }, [show]);

  if (!selectedData) return null;

  const formatDate = (date) =>
    date
      ? new Date(date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })
      : "N/A";

  const formatDateTimeIST = (date) =>
    date
      ? new Date(date).toLocaleString("en-US", {
          timeZone: "Asia/Kolkata",
          hour12: true,
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
        })
      : "N/A";

  const renderValue = (value) => (value && value !== "" ? value : "N/A");

  const renderCurrency = (value) =>
    value && value !== "" && !isNaN(value)
      ? `$ ${Number(value).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : "N/A";

  const getStatusVariant = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
      case "approved":
      case "uploaded":
        return "success";
      case "pending":
        return "warning";
      case "rejected":
        return "danger";
      default:
        return "secondary";
    }
  };

  const isImage = (url) => url?.match(/\.(jpeg|jpg|gif|png)$/i) != null;

  const renderDocViewer = () => {
    if (!selectedDoc) return null;
    const { url, documentType } = selectedDoc;

    return (
      <div className="d-flex flex-column h-100">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => setSelectedDoc(null)}
          >
            ← Back to Details
          </Button>
          <h5 className="m-0 text-truncate ms-3 me-3" title={documentType}>
            {documentType}
          </h5>
          <Button
            variant="primary"
            size="sm"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open New Tab ↗
          </Button>
        </div>
        <div
          className="flex-grow-1 shadow-sm overflow-hidden bg-white border rounded"
          style={{ minHeight: "600px" }}
        >
          {isImage(url) ? (
            <div className="d-flex justify-content-center align-items-center h-100 bg-light p-3">
              <img
                src={url}
                alt={documentType}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          ) : (
            <iframe
              src={url}
              title={documentType}
              width="100%"
              height="100%"
              style={{ border: "none", minHeight: "600px" }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderFeePlanDetails = () => {
    const feePlan = selectedData.paymentSchedule?.paymentPlan || "None";
    const arbitratorDetails =
      selectedData.paymentSchedule?.arbitratorFeeDetails;

    return (
      <div className="mt-3">
        {renderValue(feePlan) !== "N/A" && (
          <div className="mb-2">
            <strong>Fee Plan Type:</strong> {feePlan}
          </div>
        )}

        {feePlan === "FLEXIBLE" &&
          selectedData.paymentSchedule?.flexiblePlanInstallments?.length >
            0 && (
            <div className="mt-3">
              <h6 className="fw-bold small text-secondary border-bottom pb-1">
                Flexible Plan Installments
              </h6>
              <div className="table-responsive">
                <Table bordered size="sm" className="mb-0 small">
                  <thead className="bg-light">
                    <tr>
                      <th>Installment</th>
                      <th>Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedData.paymentSchedule.flexiblePlanInstallments.map(
                      (installment, index) => (
                        <tr key={index}>
                          <td>{renderValue(installment.key)}</td>
                          <td>{renderCurrency(installment.amount)}</td>
                          <td>
                            <Badge
                              bg={installment.isPaid ? "success" : "warning"}
                            >
                              {installment.isPaid ? "Paid" : "Unpaid"}
                            </Badge>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          )}

        {arbitratorDetails?.schedules?.length > 0 && (
          <div className="mt-3">
            <h6 className="fw-bold small text-secondary border-bottom pb-1">
              Arbitrator Fee Schedules
            </h6>
            <div className="table-responsive">
              <Table bordered size="sm" className="mb-0 small">
                <thead className="bg-light">
                  <tr>
                    <th>Schedule</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {arbitratorDetails.schedules.map((schedule, index) => (
                    <tr key={index}>
                      <td>{renderValue(schedule.key)}</td>
                      <td>{renderCurrency(schedule.amount)}</td>
                      <td>
                        <Badge bg={schedule.isPaid ? "success" : "warning"}>
                          {schedule.isPaid ? "Paid" : "Unpaid"}
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderArbitrators = () => {
    const rootArbitrators = selectedData.appointedArbitratorIds || [];
    const timeTableSection = selectedData.timeTable?.sections?.find(
      (s) => s.sectionIndex === 2
    );
    const arbitrators =
      rootArbitrators.length > 0
        ? rootArbitrators
        : timeTableSection?.arbitrators || [];

    return arbitrators.length > 0 ? (
      <Table bordered size="sm" responsive className="mb-0">
        <thead className="bg-light">
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {arbitrators.map((arb, index) => (
            <tr key={index}>
              <td>
                <div className="fw-bold">
                  {arb.firstName} {arb.surName}
                </div>
                <small className="text-muted">{arb.companyName}</small>
              </td>
              <td>{renderValue(arb.email)}</td>
              <td>
                <Badge bg="info" text="dark">
                  {selectedData.appointedArbitratorType || "Arbitrator"}
                </Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <p className="text-muted mb-0">No arbitrators appointed</p>
    );
  };

  const renderMeetings = () => {
    const sections = selectedData.timeTable?.sections || [];
    const allMeetings = sections.flatMap((s) => s.meetings || []);

    return allMeetings.length > 0 ? (
      <Table bordered size="sm" responsive className="mb-0">
        <thead className="bg-light">
          <tr>
            <th>Date & Time (IST)</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {allMeetings.map((meeting, index) => (
            <tr key={index}>
              <td>{formatDateTimeIST(meeting.meetingDate)}</td>
              <td>
                <Badge bg={getStatusVariant(meeting.status)}>
                  {meeting.status}
                </Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <p className="text-muted mb-0">No meetings scheduled</p>
    );
  };

  const renderOtherParties = (parties, role) => {
    if (!parties || parties.length === 0) return null;
    return (
      <div className="mt-3">
        <h6 className="fw-bold border-bottom pb-2 mb-2">
          {role} Other Parties
        </h6>
        <div className="table-responsive">
          <Table bordered size="sm" className="mb-0">
            <thead className="bg-light">
              <tr>
                <th>Name</th>
                <th>Company</th>
                <th>Role</th>
                <th>Email</th>
                <th>Doc</th>
              </tr>
            </thead>
            <tbody>
              {parties.map((p, index) => (
                <tr key={index}>
                  <td>
                    {p.firstName} {p.lastName}
                  </td>
                  <td>{p.companyName}</td>
                  <td>{p.partyType}</td>
                  <td>{p.email}</td>
                  <td>
                    {p.claimantStatement ? (
                      <Button
                        variant="link"
                        size="sm"
                        className="p-0 text-decoration-none"
                        onClick={() =>
                          setSelectedDoc({
                            url: p.claimantStatement,
                            documentType: "Claimant Statement",
                          })
                        }
                      >
                        View
                      </Button>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  };

  const renderTimeline = () => {
    const timeline = selectedData.timeline || [];
    if (timeline.length === 0)
      return <p className="text-muted small">No updates available.</p>;

    return (
      <div className="list-group list-group-flush">
        {timeline.map((item, index) => (
          <div
            key={index}
            className="list-group-item px-0 py-2 d-flex justify-content-between align-items-center bg-transparent"
          >
            <div className="me-2">
              <div
                className="fw-bold small lh-1"
                style={{ fontSize: "0.85rem" }}
              >
                {item.label}
              </div>
              <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                {formatDateTimeIST(item.date)}
              </small>
            </div>
            <Badge bg={getStatusVariant(item.status)} pill>
              {item.status}
            </Badge>
          </div>
        ))}
      </div>
    );
  };

  const InfoRow = ({ label, value }) => (
    <div className="mb-2">
      <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>
        {label}
      </small>
      <div className="fw-medium text-dark" style={{ fontSize: "0.9rem" }}>
        {value}
      </div>
    </div>
  );

  return (
    <>
      <style>
        {`
            .custom-modal-width {
              max-width: 75% !important;
            }
            @media (max-width: 992px) {
              .custom-modal-width {
                max-width: 95% !important;
              }
            }
            .card {
               border: 1px solid rgba(0,0,0,.08);
            }
            .card-header {
               border-bottom: 1px solid rgba(0,0,0,.08);
            }
          `}
      </style>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName={selectedDoc ? "" : "custom-modal-width"}
        centered
        scrollable
        fullscreen={!!selectedDoc}
        size={selectedDoc ? undefined : "lg"}
      >
        <Modal.Header closeButton className="justify-content-center">
          <Modal.Title className="text-center w-100">
            {selectedDoc
              ? "AECCI-IAC Document Viewer"
              : "AECCI-IAC Binding Dispute Details"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light">
          {selectedDoc ? (
            renderDocViewer()
          ) : (
            <div className="container-fluid p-0">
              {/* Header Status Card */}
              <div className="card mb-4 border-0 shadow-sm">
                <div className="card-body d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <div>
                    <h4 className="mb-0 text-primary fw-bold">
                      #{selectedData.appNo || "APP-N/A"}
                    </h4>
                    <div className="small text-secondary mt-1">
                      <span className="me-3">
                        <strong>Agree ID:</strong>{" "}
                        {renderValue(selectedData.agreementId)}
                      </span>
                      <span className="me-3">
                        <strong>Case ID:</strong>{" "}
                        {renderValue(selectedData.caseId)}
                      </span>
                      <span>
                        <strong>Print ID:</strong>{" "}
                        {renderValue(selectedData.printId)}
                      </span>
                    </div>
                    <span className="text-muted small d-block mt-1">
                      Application Date: {formatDate(selectedData.createdAt)}
                    </span>
                  </div>
                  <div className="text-end">
                    <Badge
                      bg={getStatusVariant(selectedData.status)}
                      className="fs-6 me-2"
                    >
                      {selectedData.status}
                    </Badge>
                    {selectedData.isApproved && (
                      <Badge
                        bg={getStatusVariant(selectedData.isApproved)}
                        className="fs-6"
                      >
                        Approval: {selectedData.isApproved}
                      </Badge>
                    )}
                  </div>
                </div>
              </div>

              <Row className="g-4">
                {/* Left Column (Details) */}
                <Col lg={8}>
                  {/* Claimant */}
                  <div className="card mb-4 shadow-sm border-0">
                    <div className="card-header bg-white fw-bold text-primary">
                      Claimant Information
                    </div>
                    <div className="card-body">
                      <Row>
                        <Col md={6}>
                          <InfoRow
                            label="Name"
                            value={renderValue(selectedData.claimantName)}
                          />
                          <InfoRow
                            label="Email"
                            value={renderValue(selectedData.email)}
                          />
                          <InfoRow
                            label="Phone"
                            value={renderValue(selectedData.phone)}
                          />
                          <InfoRow
                            label="PAN No"
                            value={renderValue(selectedData.panNo)}
                          />
                        </Col>
                        <Col md={6}>
                          <InfoRow
                            label="Company"
                            value={renderValue(selectedData.natureOfBusiness)}
                          />
                          <InfoRow
                            label="Industry"
                            value={renderValue(selectedData.industry)}
                          />
                          <InfoRow
                            label="AECCI Reg No"
                            value={renderValue(selectedData.aecciRegNo)}
                          />
                          <InfoRow
                            label="Member Type"
                            value={renderValue(selectedData.memberType)}
                          />
                          <InfoRow
                            label="Address"
                            value={`${renderValue(
                              selectedData.address
                            )}, ${renderValue(selectedData.city)}`}
                          />
                        </Col>
                      </Row>
                      {renderOtherParties(
                        selectedData.claimantOtherPartyIds,
                        "Claimant"
                      )}
                    </div>
                  </div>

                  {/* Respondent */}
                  <div className="card mb-4 shadow-sm border-0">
                    <div className="card-header bg-white fw-bold text-primary">
                      Respondent Information
                    </div>
                    <div className="card-body">
                      <Row>
                        <Col md={6}>
                          <InfoRow
                            label="Company Name"
                            value={renderValue(
                              selectedData.respondentCompanyName
                            )}
                          />
                          <InfoRow
                            label="Representative"
                            value={renderValue(
                              selectedData.respondentRepresentativeName
                            )}
                          />
                          <InfoRow
                            label="Email"
                            value={renderValue(selectedData.respondentEmail)}
                          />
                        </Col>
                        <Col md={6}>
                          <InfoRow
                            label="Website"
                            value={renderValue(selectedData.respondentWebsite)}
                          />
                          <InfoRow
                            label="Address"
                            value={`${renderValue(
                              selectedData.respondentAddress
                            )}, ${renderValue(
                              selectedData.respondentState
                            )}, ${renderValue(selectedData.respondentCountry)}`}
                          />
                        </Col>
                      </Row>
                      {/* Registered Respondent Details (Specific Table) */}
                      {selectedData.respondentId && (
                        <div className="mt-3 pt-3 border-top">
                          <h6 className="fw-bold small text-secondary mb-2">
                            Registered Respondent User
                          </h6>
                          <Table bordered size="sm" responsive className="mb-0">
                            <thead className="bg-light">
                              <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Statement</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  {renderValue(
                                    `${selectedData.respondentId.firstName} ${selectedData.respondentId.surName}`
                                  )}
                                </td>
                                <td>
                                  {renderValue(selectedData.respondentId.email)}
                                </td>
                                <td>
                                  {selectedData.claimantStatement ? (
                                    <Button
                                      variant="link"
                                      size="sm"
                                      className="p-0 text-decoration-none"
                                      onClick={() =>
                                        setSelectedDoc({
                                          url: selectedData.claimantStatement,
                                          documentType: "Claimant Statement",
                                        })
                                      }
                                    >
                                      View Statement
                                    </Button>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      )}

                      {renderOtherParties(
                        selectedData.respondentOtherPartyIds,
                        "Respondent"
                      )}
                    </div>
                  </div>

                  {/* Overview */}
                  <div className="card mb-4 shadow-sm border-0">
                    <div className="card-header bg-white fw-bold text-primary">
                      Dispute Overview
                    </div>
                    <div className="card-body">
                      <Row className="mb-3">
                        <Col md={3}>
                          <InfoRow
                            label="Product"
                            value={renderValue(selectedData.product)}
                          />
                        </Col>
                        <Col md={3}>
                          <InfoRow
                            label="Agreement Date"
                            value={formatDate(selectedData.agreementStartDate)}
                          />
                        </Col>
                        <Col md={3}>
                          <InfoRow
                            label="Dispute Date"
                            value={formatDate(selectedData.disputeStartDate)}
                          />
                        </Col>
                        <Col md={3}>
                          <InfoRow
                            label="Place"
                            value={renderValue(selectedData.place)}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col md={3}>
                          <InfoRow
                            label="Invoice Amount"
                            value={renderCurrency(
                              selectedData.commercialInvoiceAmount
                            )}
                          />
                        </Col>
                        <Col md={3}>
                          <InfoRow
                            label="Activity Amount"
                            value={renderCurrency(
                              selectedData.amountOfActivity
                            )}
                          />
                        </Col>
                        <Col md={3}>
                          <InfoRow
                            label="Claim Amount"
                            value={renderCurrency(selectedData.quantumOfClaim)}
                          />
                        </Col>
                        <Col md={3}>
                          <InfoRow
                            label="Dispute Amount"
                            value={renderCurrency(selectedData.amountInDispute)}
                          />
                        </Col>
                      </Row>
                      <div className="bg-light p-3 rounded">
                        <small className="text-secondary fw-bold d-block mb-1">
                          Description:
                        </small>
                        <p
                          className="mb-0 small"
                          style={{ whiteSpace: "pre-wrap" }}
                        >
                          {renderValue(selectedData.disputeDescription)}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Two Cards Row: Arbitrators & Meetings */}
                  <Row>
                    <Col md={12}>
                      <div className="card mb-4 shadow-sm border-0">
                        <div className="card-header bg-white fw-bold text-primary">
                          Appointed Arbitrators
                        </div>
                        <div className="card-body px-4">
                          {renderArbitrators()}
                        </div>
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="card mb-4 shadow-sm border-0">
                        <div className="card-header bg-white fw-bold text-primary">
                          Scheduled Meetings
                        </div>
                        <div className="card-body px-4">{renderMeetings()}</div>
                      </div>
                    </Col>
                  </Row>

                  {/* Documents */}
                  <div className="card mb-4 shadow-sm border-0">
                    <div className="card-header bg-white fw-bold text-primary">
                      Documents & Evidences
                    </div>
                    <div className="card-body">
                      {getDocuments(selectedData).length > 0 ? (
                        <Table
                          bordered
                          size="sm"
                          responsive
                          hover
                          className="mb-0"
                        >
                          <thead className="bg-light">
                            <tr>
                              <th>Sr No.</th>
                              <th>Document Name</th>
                              <th>Date</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {getDocuments(selectedData).map((doc, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{doc.documentType}</td>
                                <td>{formatDate(doc.uploadDate)}</td>
                                <td>
                                  <Badge bg={getStatusVariant(doc.status)}>
                                    {doc.status}
                                  </Badge>
                                </td>
                                <td>
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => setSelectedDoc(doc)}
                                  >
                                    View
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      ) : (
                        <p className="text-muted text-center mb-0">
                          No documents uploaded.
                        </p>
                      )}
                    </div>
                  </div>
                </Col>

                {/* Right Column (Timeline & Financials) */}
                <Col lg={4}>
                  {/* Timeline */}
                  <div className="card mb-4 shadow-sm border-0">
                    <div className="card-header bg-white fw-bold text-primary">
                      Case Timeline
                    </div>
                    <div className="card-body px-3 py-2">
                      {renderTimeline()}
                    </div>
                  </div>

                  {/* Financials (Expanded) */}
                  <div className="card mb-4 shadow-sm border-0">
                    <div className="card-header bg-white fw-bold text-primary">
                      Financial Summary
                    </div>
                    <div className="card-body">
                      <Table size="sm" borderless className="mb-2">
                        <tbody>
                          <tr>
                            <td>Filing Fee</td>
                            <td className="text-end fw-bold">
                              {renderCurrency(
                                selectedData.paymentSchedule?.filingFee
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>Admin Fee</td>
                            <td className="text-end fw-bold">
                              {renderCurrency(
                                selectedData.paymentSchedule?.adminFee
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>Arbitrator Fee</td>
                            <td className="text-end fw-bold">
                              {renderCurrency(
                                selectedData.paymentSchedule
                                  ?.arbitratorFeeDetails?.payableNow ||
                                  selectedData.paymentSchedule
                                    ?.arbitratorFeeDetails?.total
                              )}
                            </td>
                          </tr>
                          <tr className="border-top">
                            <td>
                              <strong>Total Fee</strong>
                            </td>
                            <td className="text-end fw-bold text-primary">
                              {renderCurrency(
                                selectedData.paymentSchedule?.totalFee
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                      {/* Inserting the detailed fee tables here */}
                      {renderFeePlanDetails()}
                    </div>
                  </div>

                  {/* Notes */}
                  {selectedData.notes && (
                    <div className="card mb-4 shadow-sm border-0">
                      <div className="card-header bg-white fw-bold text-primary">
                        Notes
                      </div>
                      <div className="card-body bg-light">
                        <p className="mb-0 small">{selectedData.notes}</p>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
